import { atom } from "recoil";
import { IBusinessType } from "../type/BusinessTypeInterface";

export const addStateAgreementBusinessType = atom({
  key: "addStateAgreementBusinessType",
  default: false,
});
export const editStateAgreementBusinessType = atom({
  key: "editStateAgreementBusinessType",
  default: false,
});
export const rowEditBusinessType = atom<IBusinessType | undefined>({
  key: "rowEditBusinessType",
  default: undefined,
});

export const selectedRowsStateBusinessType = atom<IBusinessType[]>({
  key: "selectedRowsStateBusinessType",
  default: [],
});

export const businessTypeFilterText = atom({
  key: "businessTypeFilterText",
  default: "",
});

export const businessTypeFetching = atom({
  key: "businessTypeFetching",
  default: true,
});

export const businessTypeRefetching = atom({
  key: "businessTypeRefetching",
  default: true,
});